import { average } from '../../../src/features/cron-calculator/cron-calculator-math.js';
import { api, bandBadge, el, fmt, itemIcon, LABELS } from './dom.js';
import { bandFor } from './package-history.js';

function tile(label, value, detail, unit) {
  return el('div', { className: 'mc-stat' }, [el('span', { text: label }), el('strong', {}, [value, unit ? el('small', { className: 'mc-unit', text: ` ${unit}` }) : null]), detail ? el('small', { text: detail }) : null]);
}

// Resumo pessoal: somente os registros da conta conectada.
export function renderMySummary(host, items, stats) {
  if (!items.length) return host.replaceChildren();
  const values = items.map((item) => item.cronPerPearl).filter((value) => value > 0);
  const best = items.reduce((top, item) => (item.cronPerPearl > (top?.cronPerPearl ?? -1) ? item : top), null);
  const mean = average(values);
  host.replaceChildren(
    tile('Meus pacotes', fmt.int(items.length)),
    tile('Pérolas gastas', fmt.int(items.reduce((sum, item) => sum + (item.effectivePearls || 0), 0))),
    tile('Crons obtidas', fmt.int(items.reduce((sum, item) => sum + (item.totalCrons || 0), 0))),
    tile('Minha média', Number.isFinite(mean) ? fmt.cpp(mean) : '—', best ? `Melhor: ${best.packageName}` : null, Number.isFinite(mean) ? 'Cron/Pérola' : null)
  );
  if (Number.isFinite(mean)) host.lastChild.append(bandBadge(bandFor(mean, stats)));
}

export function renderMyPurchasesLoggedOut(host, onLogin) {
  host.replaceChildren(el('div', { className: 'mc-empty mc-login-cta' }, [
    el('p', { text: 'Entre com a Twitch para ver e gerenciar os pacotes que você registrou.' }),
    el('button', { type: 'button', className: 'primary', text: 'Entrar', onclick: onLogin })
  ]));
}

// Registros do jogador autenticado, com edição e exclusão (confirmação em dois cliques).
export function renderMyPurchases(host, items, { stats, onEdit, onToggleVisibility, onDeleted, onError }) {
  if (!items.length) return host.replaceChildren(el('p', { className: 'mc-empty', text: 'Você ainda não registrou pacotes. Preencha a calculadora acima e salve no seu histórico.' }));
  host.replaceChildren(...items.map((item) => {
    const remove = el('button', { type: 'button', className: 'mc-link-button danger', text: 'Excluir' });
    remove.addEventListener('click', async () => {
      if (remove.dataset.confirm !== 'true') {
        remove.dataset.confirm = 'true';
        remove.textContent = 'Confirmar exclusão';
        setTimeout(() => { remove.dataset.confirm = ''; remove.textContent = 'Excluir'; }, 4000);
        return;
      }
      remove.disabled = true;
      try {
        await api(`/api/tools/cron-calculator/purchases/${encodeURIComponent(item.id)}`, { method: 'DELETE' });
        onDeleted(item);
      } catch (error) {
        remove.disabled = false;
        onError(error);
      }
    });
    const band = bandFor(item.cronPerPearl, stats);
    const discount = item.discountPercent ? ` (−${fmt.pct(item.discountPercent)})` : '';
    return el('article', { className: 'mc-mine-row' }, [
      item.packageIconPath ? itemIcon(item.packageIconPath) : null,
      el('div', { className: 'mc-mine-main' }, [
        el('strong', {}, [item.packageName, ' ', el('span', { className: `mc-visibility is-${item.visibility === 'private' ? 'private' : 'public'}`, text: item.visibility === 'private' ? 'Pessoal' : 'Comunidade' })]),
        el('small', { text: `${fmt.date(item.purchasedAt)} · ${LABELS.regions[item.region] || item.region} · ${fmt.int(item.effectivePearls)} Pérolas${discount} · ${fmt.int(item.totalCrons)} Crons` })
      ]),
      el('span', { className: `mc-cpp mc-band-${band}`, title: LABELS.bands[band].label, text: `${fmt.cpp(item.cronPerPearl)} Cron/Pérola` }),
      el('div', { className: 'mc-mine-actions' }, [
        el('button', { type: 'button', className: 'mc-link-button', text: 'Editar', onclick: () => onEdit(item) }),
        el('button', { type: 'button', className: 'mc-link-button', text: item.visibility === 'private' ? 'Publicar na comunidade' : 'Tornar pessoal', onclick: () => onToggleVisibility(item) }),
        remove
      ])
    ]);
  }));
}
